import { Component, Output, EventEmitter, Input, HostListener, ElementRef } from '@angular/core';

@Component({
  standalone: false,
  selector: 'scrollable-content',
  templateUrl: './scrollable-content.component.html',
  styleUrls: ['./scrollable-content.component.scss']
})
export class ScrollableContentComponent {
  @Input() backgroundColor = '#fff';
  @Output() onScroll = new EventEmitter<any>();

  @HostListener('scroll', ['$event'])
  onContainerScroll(event) {
    this.onScroll.emit(event);
  }

  constructor(public elRef: ElementRef) {
  }
}
